document.addEventListener("cart:change", updateCustomCartTotal);
document.addEventListener("cart:updated", updateCustomCartTotal);
document.addEventListener("ajaxProduct:added", updateCustomCartTotal);
document.addEventListener("shopify:section:load", updateCustomCartTotal);

async function updateCustomCartTotal() {
  const cart = await fetch('/cart.js').then(r => r.json());

  let addons_total = 0;

  cart.items.forEach(item => {
    const extra = Number(item.properties?._addons_extra_cents || 0);
    addons_total += extra * item.quantity;
  });

  const newTotal = cart.total_price + addons_total;

  const el = document.querySelector('#cart-subtotal');
  if (el) {
    el.textContent = Shopify.formatMoney(
      newTotal,
      "{{ shop.money_with_currency_format }}"
    );
  }
}
